import { render, staticRenderFns } from "./PeriodsItem.vue?vue&type=template&id=c0aa9b16&scoped=true&"
import script from "./PeriodsItem.vue?vue&type=script&lang=js&"
export * from "./PeriodsItem.vue?vue&type=script&lang=js&"
import style0 from "./PeriodsItem.vue?vue&type=style&index=0&id=c0aa9b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0aa9b16",
  null
  
)

export default component.exports